import { render } from "./Event.vue?vue&type=template&id=1b32982c"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=1b32982c&lang=scss"

import exportComponent from "/var/www/basic/vue-about-us/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__